import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import fr from 'vuetify/es5/locale/fr'
import i18n from '@/i18n'

Vue.use(Vuetify, {
    theme: {
        primary: '#d71010',
        secondary: '#ff0a0a',
        accent: '#F6F3FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    },
    customProperties: true,
    iconfont: 'fa4',
    lang: {
        locales: { fr },
        current: i18n.locale
    },
});
